/**
 * P0.7 — export do Compasso (CSV) gerado 100% client-side. Legível pelo
 * musicoterapeuta, sem jargão do app. Reusa baixarCSV (web/nativo) do módulo base.
 */
import {
  CONTEXTO_LABEL,
  ENGAJAMENTO_LABEL,
  ESTADO_REGULACAO_LABEL,
  ORIGEM_MOMENTO_LABEL,
  type ExperienciaMusical,
  type MomentoMusical,
} from "./types";

function csvCampo(v: string | number | null | undefined): string {
  const s = v === null || v === undefined ? "" : String(v);
  return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** CSV dos momentos musicais. Separador ";" (Excel PT-BR). */
export function momentosParaCSV(
  momentos: MomentoMusical[],
  experiencias: ExperienciaMusical[],
): string {
  const nome = (id: string) => experiencias.find((e) => e.id === id)?.nome ?? id;
  const cab = [
    "data e hora",
    "experiência",
    "engajamento (passo)",
    "passo nº",
    "estado antes",
    "estado depois",
    "duração (min)",
    "contexto",
    "origem",
    "confirmado",
    "notas",
  ];
  const linhas = momentos
    .slice()
    .sort((a, b) => a.data_hora.localeCompare(b.data_hora))
    .map((m) =>
      [
        new Date(m.data_hora).toLocaleString("pt-BR"),
        nome(m.experiencia_id),
        ENGAJAMENTO_LABEL[m.passo_engajamento],
        m.passo_engajamento,
        m.estado_antes ? ESTADO_REGULACAO_LABEL[m.estado_antes] : null,
        m.estado_depois ? ESTADO_REGULACAO_LABEL[m.estado_depois] : null,
        m.duracao_min,
        m.contexto ? CONTEXTO_LABEL[m.contexto] : null,
        ORIGEM_MOMENTO_LABEL[m.origem],
        m.confirmado ? "sim" : "pendente",
        m.notas,
      ]
        .map(csvCampo)
        .join(";"),
    );
  return [cab.join(";"), ...linhas].join("\r\n");
}
